<div class="p-4">
  <img class="logo-default" src="/frontend/images/logo/moneto.svg" alt="Moneto" style="width:180px;">
    <div class="moneto-loading" *ngIf="loading">
      <p>Wird geladen...</p>
    </div>
    <section *ngIf="!isSubmit">
      <form novalidate="novalidate" enctype="multipart/form-data">
        <input type="hidden" name="token" [value]="token.token">

        <div [ngSwitch]="view">
          <div *ngSwitchCase="idCard">
            <p class="mt-3" appTranslate="mobile.camera.howto"></p>

            <div class="file is-flex is-flex-direction-column is-align-items-center  is-centered is-large is-boxed mt-4">
              <div *ngIf="broadcast[front]">
                <div><img [src]="broadcast[front]" alt="front" class="front" /></div>
              </div>
              <label class="file-label">
                <span appTranslate="card.front"></span>
                <app-file-input name="card-recto" (fileReady)="onFileReady($event, front)"></app-file-input>
              </label>
            </div>

            <div class="file is-flex is-flex-direction-column is-align-items-center  is-centered is-large is-boxed mt-4">
              <div *ngIf="broadcast[back]">
                <div><img [src]="broadcast[back]" alt="back" class="back" /></div>
              </div>
              <label class="file-label">
                <span appTranslate="card.back"></span>
                <app-file-input name="card-verso" (fileReady)="onFileReady($event, back)"></app-file-input>
              </label>
            </div>
          </div>
          <div *ngSwitchCase="sign" class="wrapper mt-4" style="position: relative;width: 100%;height: 202px;border:1px solid #505050;-moz-user-select: none;-webkit-user-select: none;-ms-user-select: none;user-select: none;">
            <app-canvas></app-canvas>
          </div>
        </div>
        <div class="control mt-3">
          <button *ngIf="view === sign" class="btn btn-default text-uppercase btn-bordered border-thin circle font-size-12 lh-2 font-weight-bold ltr-sp-05 mb-2 p-3 previous" [disabled]="!hasSignature()" (click)="reset()" appTranslate="clear"></button>
          <button class="btn btn-solid text-uppercase btn-bordered border-thin circle font-size-12 lh-2 font-weight-bold ltr-sp-05 mb-2 p-3 next" [disabled]="isDirty()" (click)="next()" appTranslate="sign"></button>
        </div>
      </form>
    </section>

    <div *ngIf="isSubmit" class="is-flex is-flex-direction-column is-just-content-center is-align-items-center">
      <img src="/frontend/images/success.svg" alt="Success">
      <div class="has-text-centered">
        <h3>Besten Dank.</h3>
        <p>
          Bitte kehren Sie zur Website zurück und schliessen Sie den Suchauftrag ab.
        </p>
      </div>
    </div>
</div>
